import type {RewardsSignUpResponse} from '../transport/types';

// DIS-1329/1339: block the staff sign-up (divert to a terminal screen; the
// customer route stays open) when the middleware couldn't confirm the staff
// member's identity (Zen↔Zoho) but still returned HTTP 200 with an active card.
// The signal moved from status:'skipped' to status:'applied' +
// reason:'identity_mismatch', so we match either. Present only when the request
// carried staffStoreId.
export const isStaffActivationBlocked = (data: RewardsSignUpResponse): boolean =>
  !!data.staffActivation &&
  (data.staffActivation.status === 'skipped' ||
    data.staffActivation.reason === 'identity_mismatch');

// DIS-1384 (O-1): block the LMG-staff sign-up (divert to the same Contact-Support
// terminal screen as store-staff) when the middleware activated the loyalty card
// but the LMG ring-fence withheld staff benefits (status:'skipped' on HTTP 200).
// Present only when the request carried lmgDepartment/lmgState.
export const isLmgStaffActivationBlocked = (data: RewardsSignUpResponse): boolean =>
  data?.lmgStaffActivation?.status === 'skipped';

export type StaffConflictKind = 'variant_conflict' | 'name_mismatch' | 'generic';

// DIS-1384: classify an activation `reason` into the copy bucket the blocked
// screen renders. variant_conflict = store↔LMG mutual exclusion; name_mismatch =
// typed name vs the identity bonded to the phone; everything else (no_contact,
// identity_unconfirmed, unknown, undefined) = generic "couldn't complete".
export const classifyStaffConflict = (reason?: string): StaffConflictKind => {
  if (reason === 'variant_conflict') return 'variant_conflict';
  if (reason === 'identity_mismatch' || reason === 'payload_identity_mismatch')
    return 'name_mismatch';
  return 'generic';
};
